module.exports = __webpack_public_path__ + "static/media/Refresh.16444595.svg";